export default __webpack_public_path__ + "static/media/atram.633bbf09.png";